/* eslint-disable no-shadow,no-param-reassign,no-return-assign,no-sequences */
import Vue from 'vue';

const defaultFilter = {
  dynamicActionType: [],
  actionPriority: [],
  actionStatus: [],
  createdBy: [],
  cityDistrict: null,
  actionId: null,
  fromDate: null,
  toDate: null,
  date: 'created_at',
};

const defaultSort = {
  sort: 'updated_at',
  sortBy: 'desc',
};

const state = {
  defaultFilter,
  defaultSort,
  filter: JSON.parse(JSON.stringify(defaultFilter)),
  sort: JSON.parse(JSON.stringify(defaultSort)),
};

const mutations = {
  setSort(state, payload) {
    Vue.set(state.sort, 'sort', payload);
  },
  setSortBy(state, payload) {
    Vue.set(state.sort, 'sortBy', payload);
  },
  setDynamicActionType(state, payload) {
    Vue.set(state.filter, 'dynamicActionType', payload);
  },
  setActionPriority(state, payload) {
    Vue.set(state.filter, 'actionPriority', payload);
  },
  setActionStatus(state, payload) {
    Vue.set(state.filter, 'actionStatus', payload);
  },
  setCreatedBy(state, payload) {
    Vue.set(state.filter, 'createdBy', payload);
  },
  setCityDistrict(state, payload) {
    Vue.set(state.filter, 'cityDistrict', payload);
  },
  setActionId(state, payload) {
    Vue.set(state.filter, 'actionId', payload);
  },
  setFromDate(state, payload) {
    Vue.set(state.filter, 'fromDate', payload);
  },
  setToDate(state, payload) {
    Vue.set(state.filter, 'toDate', payload);
  },
  setDate(state, payload) {
    Vue.set(state.filter, 'date', payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
